import React, { FC } from "react";
import { IconButton, IconButtonProps } from "react-toolbox/lib/button";
import { ProgressBar } from "react-toolbox/lib/progress_bar";

import theme from "./loadingIconButtonTheme.scss";

interface LoadingIconButtonProps extends IconButtonProps {
    isLoading: boolean;
}

/**
 * @deprecated Use LoadingButton, which also accepts an icon.
 */
const LoadingIconButton: FC<LoadingIconButtonProps> = (props: LoadingIconButtonProps) => {
    const { isLoading, icon, ...buttonProps } = props;
    const Icon = isLoading ? <ProgressBar theme={theme} type="circular" /> : icon;
    return <IconButton icon={Icon} {...buttonProps} />;
};

export { LoadingIconButton, LoadingIconButtonProps };
